/**
 * Lookbook slider.
 *
 * A thin subclass of SliderComponent (global.js) - only the behaviours that
 * fight with hotspots are overridden. Declared inside the guard so the block
 * can render more than once per page without redeclaring the class.
 */
if (!customElements.get('lookbook-slider')) {
  class LookbookSlider extends SliderComponent {
    getSlideClass() {
      return '.lookbook-slide';
    }

    /**
     * TODO: delete once momentumLoop clears no-snap globally. The base class
     * only drops `.no-snap` on an arrow click, parking the track between two
     * slides after a drag. Not in stopDragging, which runs before momentum.
     */
    momentumLoop() {
      this.slider.scrollLeft += this.velX;
      this.velX *= 0.95;
      if (Math.abs(this.velX) > 0.5) {
        this.momentumID = requestAnimationFrame(this.momentumLoop.bind(this));
      } else {
        this.slider.classList.remove('dragging');
        this.slider.classList.remove('no-snap');
      }
    }

    handleMouseLeave() {
      super.handleMouseLeave();
      this.slider.classList.remove('no-snap');
    }

    /**
     * Arrows are pointless with nothing to move to, but the markup has to stay
     * for init(). Counted here rather than in Liquid, because an unfinished
     * slide is hidden rather than absent.
     */
    initPages() {
      super.initPages();

      // Read from the stylesheet rather than the inherited slidesPerPage, which
      // divides the track width by slide-plus-gap and lands a slide short once
      // the slides are gapped. Only the arrow-hiding count is corrected here.
      const visible = Array.from(this.sliderItems || []).filter(
        (slide) => slide.clientWidth > 0,
      );
      const perView =
        parseInt(
          getComputedStyle(this).getPropertyValue('--slides-per-view'),
          10,
        ) || 1;
      this.classList.toggle(
        'lookbook-slider--single',
        visible.length <= perView,
      );
    }
  }

  customElements.define('lookbook-slider', LookbookSlider);
}

/**
 * Theme editor only. Selecting a slide - or anything nested in one - scrolls
 * its slider there, so slide four can be positioned without dragging blind.
 * A new slide also needs resetPages(), or the arrows count the old total.
 */
if (
  window.Shopify &&
  window.Shopify.designMode &&
  !window.lookbookSliderEditor
) {
  window.lookbookSliderEditor = true;

  const scrollToBlock = (target, reset) => {
    const slider = target.closest('lookbook-slider');
    if (!slider) return;

    if (!slider.initialized) slider.init();
    if (reset && slider.resetPages) slider.resetPages();

    const slide = target.closest('.lookbook-slider__track > .shopify-block');
    if (!slide || !slider.slider) return;

    slider.slider.scrollTo({ left: slide.offsetLeft });
  };

  document.addEventListener('shopify:block:select', (event) =>
    scrollToBlock(event.target, false),
  );

  // Layout settles a frame or two after the block lands, so the offset is only
  // trustworthy once it has.
  document.addEventListener('shopify:block:added', (event) =>
    requestAnimationFrame(() => scrollToBlock(event.target, true)),
  );
}
